import React, { Fragment } from "react";

export const VouchersComponent = ({vouchers, title}) => {
  return (
    <Fragment>
      <div className="dashboard-card">
        <h4 className="transaction-title-header">{title}</h4>
        <table className="table table-dark oi-table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">User Email</th>
              <th scope="col">Username</th>
              <th scope="col">Token</th>
              <th scope="col">Value</th>
              <th scope="col">Network</th>
              <th scope="col">Status</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            {vouchers.map((voucher, index) => (
              <tr key={voucher.id}>
                <th scope="row">{voucher.id.substring(0, 6)}</th>
                <td>{voucher.email}</td>
                <td>{voucher.username}</td>
                <td>{voucher.token}</td>
                <td>{voucher.value}</td>
                <td>{voucher.network}</td>
                <td>{voucher.is_used > 0 ? "Used" : "Not Used"}</td>
                <td>
                  {/*<Moment format="YYYY/MM/DD">{voucher.created_at}</Moment>*/}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Fragment>
  );
};